/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
const { GoogleTagManagerVuePlugin, GoogleTagManagerVanilla } = require('./libs/GoogleTagEventManager')

// Form utility — available globally for lazy-loaded form/reg components
import Form from './utils/Form';
window.Form = Form;

import { resolveDtpClickId } from './utils/dtpClickId';

window.$gtmVanilla = new GoogleTagManagerVanilla();
const Vue = require('vue').default || require('vue');
window.Vue = Vue;
window.EventBus = new Vue();
window.volcidData = Vue.observable({ value: '', ready: false });

// Landing pages that emit the Voluum DTP loader set __dtpFlowActive from Blade, inside
// the same guard as the loader itself, so the flag and the script can never disagree.
// Kicked off here rather than from a component because the LP components are lazily
// imported - starting the handshake in created() would not begin until the chunk lands.
// The SERP is untouched: it never sets the flag and SerpContainer runs its own flow.
if (window.__dtpFlowActive === true) {
    resolveDtpClickId().then((clickId) => {
        window.volcidData.value = clickId || '';
        window.volcidData.ready = true;
    });
}

// Register vue-select lazily — only used on flow/form pages
Vue.component('v-select', () => import(/* webpackChunkName: "forms" */ 'vue-select'));

Vue.use(GoogleTagManagerVuePlugin)
Vue.use({
    install: function (Vue) {
        Vue.prototype.$sleep = async (ms = 1000) => new Promise(resolve => setTimeout(resolve, ms));
        Vue.prototype.$trans = (str, replaces) => {
            if (!str) {
                return str;
            }

            let strings = window.tenant_locale_config?.strings || {};
            let value = _.get(strings, str);

            if (replaces) {
                for (const key in replaces) {
                    value = value.replace(`:${key}`, replaces[key]);
                }
            }

            return value || str;
        }
    }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

Vue.component('hero-form', () => import(/* webpackChunkName: "forms" */ './components/HeroForm'));
Vue.component('coreg-tos', () => import(/* webpackChunkName: "forms" */ './components/CoregTos'));
Vue.component('sms-tos', () => import(/* webpackChunkName: "forms" */ './components/SmsTos'));
Vue.component('email-tos', () => import(/* webpackChunkName: "forms" */ './components/EmailTos'));
Vue.component('form-tos', () => import(/* webpackChunkName: "forms" */ './components/FormTos'));
Vue.component('form-date', () => import(/* webpackChunkName: "forms" */ './components/FormFields/FormDate'));

Vue.component('contact-us-form', () => import(/* webpackChunkName: "misc" */ './components/ContactUsForm'));
Vue.component('navy-hosted-apply-form', () => import(/* webpackChunkName: "forms" */ './components/NavyHostedApplyComponent'));
Vue.component('refine-component', () => import(/* webpackChunkName: "misc" */ './components/RefineComponent'));
Vue.component('unsubscribe-component', () => import(/* webpackChunkName: "misc" */ './components/UnsubscribeComponent'));
Vue.component('sand-box-sms-form', () => import(/* webpackChunkName: "sandbox" */ './components/SandBoxSmsForm.vue'));
Vue.component('sand-box-email-form', () => import(/* webpackChunkName: "sandbox" */ './components/SandBoxEmailForm.vue'));
Vue.component('serp-job-component', () => import(/* webpackChunkName: "serp-legacy" */ './components/RenderJobSerp.vue'));
Vue.component('serp-job-component-uk', () => import(/* webpackChunkName: "serp-legacy" */ './components/RenderJobSerpUk.vue'));
Vue.component('serp-job-component-jm', () => import(/* webpackChunkName: "serp-legacy" */ './components/RenderJobSerpJM.vue'));
Vue.component('serp-job-skel', require('./components/RenderJobSkel.vue').default); // eager: SERP skeleton shown during load
Vue.component('serp-om-sponsored', () => import(/* webpackChunkName: "serp-legacy" */ './components/RenderOmSponsored.vue'));
Vue.component('serp-pagination', require('./components/SerpPagination.vue').default); // eager: SERP blade template
Vue.component('new-job-select', () => import(/* webpackChunkName: "misc" */ './components/NewJobSelect'));
Vue.component('tracking', () => import(/* webpackChunkName: "flow" */ './components/Tracking.vue'));
Vue.component('om-ad-imp-trigger', require('./components/OMAdImpTracking.vue').default); // eager: master layout (every page)
Vue.component('question-age-range', () => import(/* webpackChunkName: "flow" */ './components/QuestionAgeRange.vue'));
Vue.component('xml-job-serp-lp', () => import(/* webpackChunkName: "lps" */ './components/RenderJobsXmlSerp.vue'));
Vue.component('serp-xml-job-feature', require('./components/RenderXmlJobSerp.vue').default); // eager: SERP blade template
Vue.component('serp-unified-ad-placement', () => import(/* webpackChunkName: "serp-legacy" */ './components/RenderOmAdsUnified.vue'));
Vue.component('serp-unified-ad-placement-jm', () => import(/* webpackChunkName: "serp-legacy" */ './components/RenderOmAdsUnifiedJM.vue'));

// new path stuff
Vue.component('ad-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/AdOfferNavigatorComponent'));
Vue.component('job-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/OfferNavigatorComponent'));
Vue.component('lsemail-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/InternalCoregNavigatorComponent'));
Vue.component('path-impression', () => import(/* webpackChunkName: "path" */ './components/Path/Tracking'));
Vue.component('static-timed-offer', () => import(/* webpackChunkName: "path" */ './components/Path/StaticSlide'));
Vue.component('edu-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/EduNavigatorComponent'));
Vue.component('ssdi-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/SsdiNavigatorComponent'));
Vue.component('aca-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/AcaQuestionComponent'));
Vue.component('ds-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/DirectSalesComponent'));
Vue.component('edu-v2-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/EduV2NavigatorComponent'));
Vue.component('edu-v3-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/EduV3NavigatorComponent'));
Vue.component('age-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/AgeQuestionComponent'));
Vue.component('hib-path-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/HibDirectSalesComponent'));
Vue.component('ds-address-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/DirectSalesAddressComponent'));
Vue.component('ds-hosted-navigation', () => import(/* webpackChunkName: "path" */ './components/Path/DirectSalesHostedApplyComponent'));

//new Reg stuff
Vue.component('reg-423', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-423'));
Vue.component('reg-430', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-430'));
Vue.component('reg-433', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-433'));
Vue.component('reg-426', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-426'));
Vue.component('reg-712', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-712'));
Vue.component('reg-424', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-424'));
Vue.component('reg-425', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-425'));
Vue.component('reg-427', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-427'));
Vue.component('reg-428', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-428'));
Vue.component('reg-713', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-713'));
Vue.component('reg-356', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-356-modal'));
Vue.component('reg-357', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-357-modal'));
Vue.component('reg-366', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-366-modal'));
Vue.component('reg-360', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-360-modal'));
Vue.component('reg-355-modal', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-355-modal'));
Vue.component('reg-354-modal', () => import(/* webpackChunkName: "regs" */ './components/Regs/Reg-354-modal'));

//new landing page stuff & tracking
Vue.component('performance-skip', () => import(/* webpackChunkName: "lps" */ './components/Tracking/PerformanceComponent'));
Vue.component('lp-988', () => import(/* webpackChunkName: "lps" */ './components/Lps/Lp-988'));
Vue.component('lp-655', () => import(/* webpackChunkName: "lps" */ './components/Lps/Lp-655'));

//new serp stuff
Vue.component('style3-skel-card', require('./components/Serp/Style3SkelCard').default); // eager: skeleton shown immediately during load
Vue.component('single-modal-jobserp', () => import(/* webpackChunkName: "serp" */ './components/Serp/SingleModalJobSerp.vue'));
Vue.component('serp-job-component-uk-jm', () => import(/* webpackChunkName: "serp" */ './components/Serp/RenderJobSerpJMUK'));
Vue.component('master-serp', () => import(/* webpackChunkName: "serp" */ './components/Serp/MasterSerpRender'));
Vue.component('om-ads-sponsored', () => import(/* webpackChunkName: "serp" */ './components/Serp/RenderOmSponsored'));
Vue.component('serp-listing-style-1', () => import(/* webpackChunkName: "serp" */ './components/Serp/RenderSerpStyle1'));
Vue.component('serp-listing-style-2', () => import(/* webpackChunkName: "serp" */ './components/Serp/RenderSerpStyle2'));
Vue.component('serp-listing-style-3', () => import(/* webpackChunkName: "serp" */ './components/Serp/RenderSerpStyle3'));
Vue.component('filter-bar', () => import(/* webpackChunkName: "serp" */ './components/Serp/FilterBar'));
Vue.component('style3-job-card', () => import(/* webpackChunkName: "serp" */ './components/Serp/Style3JobCard'));
Vue.component('match-button', () => import(/* webpackChunkName: "serp" */ './components/Serp/MatchButton'));
Vue.component('serp-container', () => import(/* webpackChunkName: "serp" */ './components/Serp/SerpContainer'));
Vue.component('scroll-top-button', () => import(/* webpackChunkName: "serp" */ './components/Serp/ScrollTopButton'));

//serp path
Vue.component('modal-path', () => import(/* webpackChunkName: "serp" */ './components/Serp/ModalPath'));

//new nav stuff2
Vue.component('exit-pop-modal', () => import(/* webpackChunkName: "nav" */ './components/Nav/ExitModal'));
Vue.component('search-form', () => import(/* webpackChunkName: "nav" */ './components/Nav/SearchForm'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.prototype.$capitalizeFirstLetter = function (x) {
    return x.charAt(0).toUpperCase() + x.slice(1);
}
Vue.prototype.$isNumber = function (x) { return /^\d+$/.test(x); }

Vue.prototype.$isFacebookInAppBrowser = function () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Common patterns for in-app browsers
    if (
        /FBAN|FB_IAB|FBSV|FBRV|FBAV|GSA|KAIOS|Instagram|Barcelona|LinkedInApp|Line|Messenger|VK|Twitter|musical_ly|Pinterest|Snapchat|WeChat|QQ|Alipay|DingTalk|Douban|Douyin|Kuaishou|TikTok|UCBrowser|BaiduBrowser|SogouMobileBrowser|HuaweiBrowser|MiuiBrowser|DuckDuckGo|Ddg|AdsBot-Google|Ecosia|BingWeb/i.test(userAgent) ||
        // iOS WebView
        (/(iPhone|iPad|iPod).*AppleWebKit(?!.*Safari)/i.test(userAgent) && !/CriOS|EdgiOS|FirefoxiOS/i.test(userAgent)) ||
        // Android WebView (detect 'wv')
        /Android.*wv/i.test(userAgent)
    ) {
        return true;
    }

    return false;
}

Vue.prototype.$redirectInapp = function () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const url = new URL(window.location.href);
    if (url.searchParams.get("mredirected") === "true") {

        url.searchParams.delete("mredirected");
        window.history.replaceState({}, "", url.toString());
    } else {
        const timer = setTimeout(() => {
            if (typeof window !== "undefined") {
                const baseUrl = window.location.origin + window.location.pathname;

                $fullu = new URLSearchParams(document.location.search);

                if (!vm.fullu.has('mredirected')) {
                    vm.fullu.set('mredirected', 'true');
                }
                // Construct redirection URL based on phone type
                if (/Android/.test(userAgent)) {
                    window.location.href = `intent:${baseUrl}?${fullu.toString()}#Intent;scheme=https;package=com.android.chrome;end`; // open in chrome browser

                    // open in default browser (most of the time it is not chrome, that is why open in chrome browser is preferred)
                    // window.location.href = `intent:${baseUrl}?redirected=true#Intent;end`; // open in default browser
                } else if (/iPhone/.test(userAgent)) {
                    window.location.href = `x-safari-${baseUrl}?${fullu.toString()}`; // open in safari browser

                    // open in shortcuts app -> which will navigate to the default browser of the ios device (not recommended, because it is opening shortcuts app)
                    // window.location.href =  `shortcuts://x-callback-url/run-shortcut?name=${crypto.randomUUID()}&x-error=${encodeURIComponent("https://example.com")}`
                }
            }
        }, 1000); // Delay redirection by 2 seconds
    }
}

Vue.prototype.$jornaya = function () {
    // Guard: if leadid.blade.php already loaded the script (or it was previously injected),
    // don't add a second copy — just return true so the component continues normally.
    if (document.getElementById('LeadiDscript_campaign')) {
        return true;
    }
    const s = document.createElement("script");
    s.id = 'LeadiDscript_campaign';
    s.type = 'application/javascript';
    s.async = true;
    s.src = '//create.lidstatic.com/campaign/a14599c9-7cbe-fd05-a683-a43d2fc22d1a.js?snippet_version=2';
    document.head.appendChild(s);
    return true;
}

const app = new Vue({
    el: '#app',
});

// Search open button mobile
$('#searchbuttonmobile').on('click', function (e) {
    e.preventDefault();
    let jobListContainer = $('.main-container');

    $('.top-search-mob').toggle();

    if (!jobListContainer.hasClass('search-top-fix')) {
        jobListContainer.addClass('search-top-fix');
        $('.loc-content-top').hide();
        $('.herosearchbutton').text('Find');
        $(this).find('i').text('close');

    } else {
        jobListContainer.removeClass('search-top-fix');
        $(this).find('i').text('search');
        $('.herosearchbutton').text('Find Jobs');
        $('.loc-content-top').show();
    }
});

// US phone formatting
$(".phoneinput").on("keyup paste", function () {
    // Remove invalid chars from the input
    let input = this.value.replace(/[^0-9\(\)\s\-]/g, "");
    let inputlen = input.length;
    // Get just the numbers in the input
    let numbers = this.value.replace(/\D/g, '');
    let numberslen = numbers.length;
    // Value to store the masked input
    let newval = "";

    // Loop through the existing numbers and apply the mask
    for (let i = 0; i < numberslen; i++) {
        if (i === 0) newval = "(" + numbers[i]; else if (i === 3) newval += ") " + numbers[i]; else if (i === 6) newval += "-" + numbers[i]; else newval += numbers[i];
    }

    // Re-add the non-digit characters to the end of the input that the user entered and that match the mask.
    if (inputlen >= 1 && numberslen === 0 && input[0] === "(") newval = "("; else if (inputlen >= 6 && numberslen === 3 && input[4] === ")" && input[5] === " ") newval += ") "; else if (inputlen >= 5 && numberslen === 3 && input[4] === ")") newval += ")"; else if (inputlen >= 6 && numberslen === 3 && input[5] === " ") newval += " "; else if (inputlen >= 10 && numberslen === 6 && input[9] === "-") newval += "-";
    $(this).val(newval.substring(0, 14));
});

function decodeJwtResponse(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

const handleGoogleSSO = function (response) {
    const responsePayload = decodeJwtResponse(response.credential);

    const ssoHandled = new CustomEvent('sso-handled', {
        bubbles: true,
        detail: {
            first_name: responsePayload.given_name,
            last_name: responsePayload.family_name,
            email: responsePayload.email,
            provider: 'google'
        },
    });

    window.dispatchEvent(ssoHandled);
}

window.handleGoogleSSO = handleGoogleSSO;

window.addEventListener('click', function (event) {
    if (!/^\/search(\/|$)/.test(window.location.pathname)) {
        return;
    }
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let isWebView = false;
    if (
        /FBAN|FB_IAB|FBSV|FBRV|FBAV|GSA|KAIOS|Instagram|Barcelona|LinkedInApp|Line|Messenger|VK|Twitter|musical_ly|Pinterest|Snapchat|WeChat|QQ|Alipay|DingTalk|Douban|Douyin|Kuaishou|TikTok|UCBrowser|BaiduBrowser|SogouMobileBrowser|HuaweiBrowser|MiuiBrowser|DuckDuckGo|Ddg|AdsBot-Google|Ecosia|BingWeb/i.test(userAgent) ||
        // iOS WebView
        (/(iPhone|iPad|iPod).*AppleWebKit(?!.*Safari)/i.test(userAgent) && !/CriOS|EdgiOS|FirefoxiOS/i.test(userAgent)) ||
        // Android WebView (detect 'wv')
        /Android.*wv/i.test(userAgent)
    ) {
        isWebView = true;
    }
     if (!isWebView) {
        return;
    }
    const target = event.target instanceof Element ? event.target : null;
    const isSerp = target && target.closest('#serp-container');

    if (!isSerp) {
        return;
    }

    // Resolve the nearest anchor element (handles clicks on child elements like <img>)
    const el = target.closest('a');

    // handle only with href
    if (!el || !el.href) {
        return;
    }

    if (isWebView && el.target === '_blank' && el.href.startsWith('https://ls-jobs.co/v1')) {
        event.preventDefault();
        window.location.href = el.href;
        return;
    }
});

